import * as React from 'react';

/**
 * @return {React.ReactElement}
 * @constructor
 */
export default function SmallClose(): React.ReactElement {
  return (
    <svg width="8" height="8" viewBox="0 0 8 8" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.88889 4L8 0.888889L7.11111 0L4 3.11111L0.888889 0L2.11928e-07 0.888889L3.11111 4L0 7.11111L0.888889 8L4 4.88889L7.11111 8L8 7.11111L4.88889 4Z" />
    </svg>
  );
}
